import { React } from "react";
import { Link } from "react-router-dom";
import styles from "../../../Styles/Login.module.css";
import logo from "../../../Assets/logo/logo.svg";
import ResetPasswordFlow from "./ResetForm";
function Reset() {
  return (
    <div className={styles.register}>
      <div className={styles.wrapper}>
        <div className={styles.content}>
          <div className={styles.content_left_wrapper}>
            <div className={styles.content_left}>
              <div className={styles.logo_wrapper}>
                <img src={logo} alt="logo" />
                <p className={styles.agent_pro}>Agent Pro</p>
              </div>
            </div>
          </div>
          <div className={styles.content_right_wrapper}>
            <div className={styles.content_right}>
              <p className={styles.welcome_back}></p>
              <div className={styles.input_details}>
                <ResetPasswordFlow />
              </div>
              <div className={styles.navigation_details}>
                <div className={styles.navigation}>
                  <Link className={styles.forgot_pass} to="/">
                    Back to Login
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles}></div>
    </div>
  );
}

export default Reset;
